// extracted by mini-css-extract-plugin
export default {"modal":"StoreSwitchModal_modal__0jXxd"};